var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5H2.3C2.01997 3.5 1.87996 3.5 1.77301 3.5545C1.67893 3.60244 1.60243 3.67893 1.55449 3.77301C1.5 3.87996 1.5 4.01998 1.5 4.3V9.7C1.5 9.98005 1.5 10.1201 1.55449 10.227C1.60243 10.3211 1.67893 10.3976 1.77301 10.4455C1.87996 10.5 2.01997 10.5 2.3 10.5H4.5M4.5 10.5H7.5M4.5 10.5V2.3C4.5 2.01997 4.5 1.87996 4.55449 1.77301C4.60243 1.67893 4.67893 1.60243 4.77301 1.55449C4.87996 1.5 5.01995 1.5 5.3 1.5H6.7C6.98005 1.5 7.12005 1.5 7.227 1.55449C7.3211 1.60243 7.39755 1.67893 7.4455 1.77301C7.5 1.87996 7.5 2.01997 7.5 2.3V10.5M7.5 10.5H9.7C9.98005 10.5 10.1201 10.5 10.227 10.4455C10.3211 10.3976 10.3976 10.3211 10.4455 10.227C10.5 10.1201 10.5 9.98005 10.5 9.7V6.3C10.5 6.01995 10.5 5.87995 10.4455 5.773C10.3976 5.6789 10.3211 5.60245 10.227 5.5545C10.1201 5.5 9.98005 5.5 9.7 5.5H7.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart_icon.2263d3feb2dfed49e04383ce43ad8a8d.svg";
export { ForwardRef as ReactComponent };